<template>
	<main class="mypage password_change">
		<UserMenu v-if="displayStore.isDesktop" />
		<article class="phoneInfo">
			<h6>비밀번호 변경</h6>
			<section class="phone_form">
				<img src="@/assets/img/mypage/lock.png" alt="잠금장치 아이콘" loading="lazy" />
				<p>회원님의 개인정보를 안전하게 보호하기 위해<br />비밀번호를 입력해 주세요.</p>

				<div class="c_fieldArea">
					<FieldLayout :error="errors.password">
						<InputPasswordLock
							v-model="password"
							:class="{ error: errors.password }"
							:show-error-icon="errors.password"
							:placeholder="ERROR_PASSWORD_REQUIRED"
							:show-toggle="true"
						/>
					</FieldLayout>
					<button class="c_button radius-x-small primary-fill save" :disabled="!password" @click="onClickConfirm">
						확인
					</button>
				</div>
				<div class="password">
					<span>비밀번호를 잊으셨나요?</span>
					<button class="c_button" @click="$router.push('/auth/find-pw')">
						비밀번호 찾기<img src="@/assets/img/common/arrow_next.svg" alt="비밀번호 찾기 아이콘" loading="lazy" />
					</button>
				</div>
			</section>
		</article>
	</main>
</template>

<script setup lang="ts">
// component
// lib
import { useRouter } from 'vue-router';
// validation
import { useForm } from 'vee-validate';
import * as yup from 'yup';

// api
import { useMypageCheckPasswordApi } from '@/api/mypage';
import InputPasswordLock from '@/components/atom/input/InputPasswordLock.vue';
import FieldLayout from '@/components/form/FieldLayout.vue';
import UserMenu from '@/components/mypage/UserMenu.vue';
// constant
import { ERROR_PASSWORD_REQUIRED, ERROR_PASSWORDS_DO_NOT_MATCH } from '@/constants/title';
// store
import { useDisplayStore } from '@/stores/display';

// -----variable-----
const displayStore = useDisplayStore();
const router = useRouter();

// -----validation-----
const { errors, defineField, setFieldError } = useForm({
	validationSchema: yup.object({
		password: yup.string(),
	}),
	initialValues: {
		password: '',
	},
});
const [password] = defineField('password'); //패스워드

// -----api-----
const { mutateAsync: checkPassword } = useMypageCheckPasswordApi();

// -----function-----
const onClickConfirm = async () => {
	const res = await checkPassword({
		member_password: password.value,
	});
	if (res.data.success) {
		router.push('/my/pw-change/new-pw-change');
	} else {
		setFieldError('password', ERROR_PASSWORDS_DO_NOT_MATCH);
	}
};
</script>

<style lang="scss" scoped>
.password_change {
	margin-bottom: 7.2rem;
	@media screen and (max-width: 1280px) {
		padding: 0rem 2rem;
		margin-top: var(--mobile-header-height);
	}
	.phoneInfo {
		display: flex;
		flex-direction: column;
		max-width: 40rem;
		margin: 0 auto;
		width: 100%;
		gap: var(--space-xxx-large);
		@media screen and (max-width: 1280px) {
			justify-content: center;
		}
		.phone_form {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: var(--space-x-large);
			p {
				font-size: var(--font-s-regular);
				font-weight: var(--font-w-light);
				line-height: 2.3rem;
				text-align: center;
			}
			img {
				width: 12rem;
				height: auto;
			}
		}
		.c_fieldArea {
			gap: var(--space-mid);
			width: 100%;
			button {
				height: 4.8rem;
			}
		}
		.password {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			font-size: var(--font-s-mid);
			font-weight: var(--font-w-regular);
			line-height: 1.79rem;
			color: var(--color-base-mid);
			button {
				font-weight: var(--font-w-medium);
				color: var(--color-base-white);
				padding: 0.8rem 0rem 0rem 0rem;
				height: fit-content;
			}
			img {
				width: 1.8rem;
				height: auto;
			}
		}
	}
}
</style>
